import $ from "cash-dom";

export default (function () {
    function init() {
        jdmn.log("function_menu-actions.js initialized", "green");

        /**
         * Menu Toggle
         */
        (function () {
            var selector = ".menu-toggle";
            if (!$(selector).length) return;

            $(selector).on("click", function (_e) {
                var $instance = $(this);
                var $navigation = $("#menu");

                $instance.toggleClass("on");
                $navigation.toggleClass("on");
                $("html").toggleClass("menu-open");
            });
        })();

        /**
         * Top Link
         */
        (function () {
            var selector = "[href='#top']";
            if (!$(selector).length) return;

            $(selector).on("click", function (_e) {
                _e.preventDefault();

                window.scrollTo({
                    top: 0,
                    behavior: "instant",
                });
            });
        })();

        /**
         * Jump Links
         */
        (function () {
            var selector = "#internal a";
            if (!$(selector).length) return;

            var $navigation = $("#menu");

            $(selector).on("click", function (_e) {
                _e.preventDefault();

                var $instance = $(this);
                var $target = $($instance.attr("href")).find(".chapter-index");

                $target[0].scrollIntoView({ behavior: "instant" });
                $(".menu-toggle").toggleClass("on");
                $navigation.toggleClass("on");
                $("html").toggleClass("menu-open");
            });
        })();

        /**
         * Share Button
         */
        (function () {
            var selector = ".share";
            if (!$(selector).length) return;

            $(selector).on("click", function (_e) {
                var string = jdmn_l10n.link_copied;
                var $toast = $(
                    `<div class="fixed center-self px-1.0 py-0.5 bg-black c-accent transition-md fade-in" style="z-index: 9999">${string}</div>`,
                );

                navigator.clipboard.writeText(window.location.href);

                $("body").append($toast);
                setTimeout(function () {
                    $toast.addClass("on").on("transitionend", function () {
                        setTimeout(function () {
                            $toast.removeClass("on").on("transitionend", function () {
                                $toast.remove();
                            });
                        }, 1500);
                    });
                }, 0);
            });
        })();
    }

    $(document).ready(init);
})();
